/* eslint-disable no-unused-vars */
import $ from 'jquery';
import jwt from 'jwt-decode'
import moment from 'moment'
import * as CryptoJS from 'crypto-js';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import sha256 from 'crypto-js/sha256';
//const crypto = require('crypto');


/**Defining the application routes */
const ROUTE = {
    index: '/',
    // login: '/login',
    // home: '/home',
    // dashboard: '/dashboard',
    //Adding the get started route to the navigation stack
    getstarted: '/getstarted',
    form: '/form',
    //clients: '/clients',
    // approved: '/approved',
    // rejected: '/rejected',
    selfserve: '/selfserve',
    privacypolicy: '/privacypolicy',
    feedbackchannel:'/feedbackchannel',
    guarantee: '/guarantee',
    //for the admin
    adminservicerequests: '/adminselfservices',
    all: '/*'
}


export default ROUTE;


export const SortSelect = (select) => {
    $("#elmt").append($("#elmt option")
        .remove().sort(function (a, b) {
            const at = $(a).text(),
                bt = $(b).text();
            return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
        }));
};

export const LogoutBoolean = () => {
    //const token = sessionStorage.getItem('token');

    const expTime = sessionStorage.getItem('exp');
    // console.log('sign in', jwt(token))
    const date = new Date(expTime * 1000);
    var hours = date.getHours();
    // Minutes part from the timestamp
    var minutes = "0" + date.getMinutes();
    // Seconds part from the timestamp
    var seconds = "0" + date.getSeconds();

    // Will display time in 10:30:23 format
    const formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

    const dateNow = new Date()
    //const logoutMinutes = dateNow.getMinutes();
    //const logoutSeconds = dateNow.getSeconds();
    //const logouthour = dateNow.getHours();

    const formattedLogout = "13:41:58"; 

    return formattedTime === formattedLogout;
}
//function s(x) {return x.charCodeAt(0);}

export const Signature = (query) => {
    let now = moment();
    const timestamp = now.format("YYYYMMDDHHmmss");
    // const timestamp = "20210304090258";
    //const username = "bfQZWIgmT0aSxI2vzh0CPA==";
    const username = "KYCUI-TEST";
    // const username = "KYCUI-TEST";
    // const trueSignature = "05fa5604f99a2f4f1fb1e743c6fdf8e6d5d2e0d08b394d0a56d77199152b68c4"
    // const truemsg = "bfQZWIgmT0aSxI2vzh0CPA==54feac17363255bb753f35e69fb0ed5a7fd77115997957b4dfc6d6e9d015d9b520210225170056auth"
    // const query = "KYC";
    // const password1 = "5c382fe3d6b3cbe0cd55542a7a7fe8137e76072e4c81d624de0466bdb9c7591d";
    //const password1 = "54feac17363255bb753f35e69fb0ed5a7fd77115997957b4dfc6d6e9d015d9b5";
    //const password1 = "06a082ef5e910628cb73fa556dd2b8abc8b744fc2ec1259911077632469187d7";
    const password1 = "54feac17363255bb753f35e69fb0ed5a7fd77115997957b4dfc6d6e9d015d9b5";
    
    // const password = "KYCtest202@";
    const password = "KYCtest2021@";
    
    const api_key = "moeXQUbcLttThhuHIaw5ETLBdSZMSpl3i+7Ux8NN44XGSy2tumPe7LGVowDjuMe+tUU5Qi5hY/H15fdzfB7eE5zlhpBQ4UHu4IYJVHWDyOQ="
    //const api_key = "k5ctakxG41WrrJDy3k08Xs6OHgDM7JHZm+ZEGI7YCYO/8iud8R3kFahTNiEjRAkOrPBZpTlup5diYi9eszLrqDIPKaql4L/e";
    
    //const api_key = "8U3rgwU*gUz^7kYd@U?n%+X_s_x?VA&dKS_k3Dptv*N=Wwf*g#4CUP2HV^3NmRpV+QHe&Z";
    // const hashPassword = crypto.createHmac('sha256', api_key)

    // const hashPassword = crypto.createHash('sha256')
    // const hashPassword1 = hashPassword.update(password)
    // const passwordValue = hashPassword1.digest('hex');

    // console.log('true password', password1)
    // console.log('password', passwordValue)
    // console.log('password boolean', password1 === passwordValue)
    
    //---------------create hmac--------------
    //const msg = `${username}${password1}${timestamp}${query}`;
    //const hashhmac = crypto.createHmac('sha256', api_key)
    //hashhmac.update(msg);
    //const signatureValue = hashhmac.digest('hex')

    //---------------Creating the Hmac----------- 2nd approach has replaced the one above.
    //const message, nonce, path, privateKey; // ...
    const msg = `${username}${password1}${timestamp}${query}`;
    //const hashDigest = sha256(msg);
    const signatureValue = HmacSHA256(msg, api_key);


    const netValue = { 
        timestamp, signatureValue
    }
    return netValue;
}
// const msg ="KYCUI-TEST54feac17363255bb753f35e69fb0ed5a7fd77115997957b4dfc6d6e9d015d9b520210319162216KYC";

export const Encryption = (number) => {
    // console.log(number);
    // const api_key = "t0A0cD0jAl0at5YUpy3HxG8e"
    const api_key = "7061737323313233"
    // const api_key = "8DnnxtbhmzmXV2YvfZ4LWtuRIHTdZ+0AjiAPB3zNL7Za220FfPWdpmZ2H+s9WHIE4qVsLgVSRZz8x2pnTr9O5bJiUR3gRHn8"
    var key = CryptoJS.enc.Utf8.parse(api_key);
        var iv = CryptoJS.enc.Utf8.parse(api_key);
        var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(number), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        return encrypted.toString();
}

export const Countries = [{
  "name": "Afghanistan",
  "dial_code": "93",
  "emoji": "🇦🇫",
  "code": "AF"
},
{
  "name": "Aland Islands",
  "dial_code": "358",
  "emoji": "🇦🇽",
  "code": "AX"
},
{
  "name": "Albania",
  "dial_code": "355",
  "emoji": "🇦🇱",
  "code": "AL"
},
{
  "name": "Algeria",
  "dial_code": "213",
  "emoji": "🇩🇿",
  "code": "DZ"
},
{
  "name": "AmericanSamoa",
  "dial_code": "1684",
  "emoji": "🇦🇸",
  "code": "AS"
},
{
  "name": "Andorra",
  "dial_code": "376",
  "emoji": "🇦🇩",
  "code": "AD"
},
{
  "name": "Angola",
  "dial_code": "244",
  "emoji": "🇦🇴",
  "code": "AO"
},
{
  "name": "Anguilla",
  "dial_code": "1264",
  "emoji": "🇦🇮",
  "code": "AI"
},
{
  "name": "Antarctica",
  "dial_code": "672",
  "emoji": "🇦🇶",
  "code": "AQ"
},
{
  "name": "Antigua and Barbuda",
  "dial_code": "1268",
  "emoji": "🇦🇬",
  "code": "AG"
},
{
  "name": "Argentina",
  "dial_code": "54",
  "emoji": "🇦🇷",
  "code": "AR"
},
{
  "name": "Armenia",
  "dial_code": "374",
  "emoji": "🇦🇲",
  "code": "AM"
},
{
  "name": "Aruba",
  "dial_code": "297",
  "emoji": "🇦🇼",
  "code": "AW"
},
{
  "name": "Australia",
  "dial_code": "61",
  "emoji": "🇦🇺",
  "code": "AU"
},
{
  "name": "Austria",
  "dial_code": "43",
  "emoji": "🇦🇹",
  "code": "AT"
},
{
  "name": "Azerbaijan",
  "dial_code": "994",
  "emoji": "🇦🇿",
  "code": "AZ"
},
{
  "name": "Bahamas",
  "dial_code": "1242",
  "emoji": "🇧🇸",
  "code": "BS"
},
{
  "name": "Bahrain",
  "dial_code": "973",
  "emoji": "🇧🇭",
  "code": "BH"
},
{
  "name": "Bangladesh",
  "dial_code": "880",
  "emoji": "🇧🇩",
  "code": "BD"
},
{
  "name": "Barbados",
  "dial_code": "1246",
  "emoji": "🇧🇧",
  "code": "BB"
},
{
  "name": "Belarus",
  "dial_code": "375",
  "emoji": "🇧🇾",
  "code": "BY"
},
{
  "name": "Belgium",
  "dial_code": "32",
  "emoji": "🇧🇪",
  "code": "BE"
},
{
  "name": "Belize",
  "dial_code": "501",
  "emoji": "🇧🇿",
  "code": "BZ"
},
{
  "name": "Benin",
  "dial_code": "229",
  "emoji": "🇧🇯",
  "code": "BJ"
},
{
  "name": "Bermuda",
  "dial_code": "1441",
  "emoji": "🇧🇲",
  "code": "BM"
},
{
  "name": "Bhutan",
  "dial_code": "975",
  "emoji": "🇧🇹",
  "code": "BT"
},
{
  "name": "Bolivia, Plurinational State of",
  "dial_code": "591",
  "emoji": "🇧🇴",
  "code": "BO"
},
{
  "name": "Bosnia and Herzegovina",
  "dial_code": "387",
  "emoji": "🇧🇦",
  "code": "BA"
},
{
  "name": "Botswana",
  "dial_code": "267",
  "emoji": "🇧🇼",
  "code": "BW"
},
{
  "name": "Brazil",
  "dial_code": "55",
  "emoji": "🇧🇷",
  "code": "BR"
},
{
  "name": "British Indian Ocean Territory",
  "dial_code": "246",
  "emoji": "🇮🇴",
  "code": "IO"
},
{
  "name": "Brunei Darussalam",
  "dial_code": "673",
  "emoji": "🇧🇳",
  "code": "BN"
},
{
  "name": "Bulgaria",
  "dial_code": "359",
  "emoji": "🇧🇬",
  "code": "BG"
},
{
  "name": "Burkina Faso",
  "dial_code": "226",
  "emoji": "🇧🇫",
  "code": "BF"
},
{
  "name": "Burundi",
  "dial_code": "257",
  "emoji": "🇧🇮",
  "code": "BI"
},
{
  "name": "Cambodia",
  "dial_code": "855",
  "emoji": "🇰🇭",
  "code": "KH"
},
{
  "name": "Cameroon",
  "dial_code": "237",
  "emoji": "🇨🇲",
  "code": "CM"
},
{
  "name": "Canada",
  "dial_code": "1",
  "emoji": "🇨🇦",
  "code": "CA"
},
{
  "name": "Cape Verde",
  "dial_code": "238",
  "emoji": "🇨🇻",
  "code": "CV"
},
{
  "name": "Cayman Islands",
  "dial_code": "345",
  "emoji": "🇰🇾",
  "code": "KY"
},
{
  "name": "Central African Republic",
  "dial_code": "236",
  "emoji": "🇨🇫",
  "code": "CF"
},
{
  "name": "Chad",
  "dial_code": "235",
  "emoji": "🇹🇩",
  "code": "TD"
},
{
  "name": "Chile",
  "dial_code": "56",
  "emoji": "🇨🇱",
  "code": "CL"
},
{
  "name": "China",
  "dial_code": "86",
  "emoji": "🇨🇳",
  "code": "CN"
},
{
  "name": "Christmas Island",
  "dial_code": "61",
  "emoji": "🇨🇽",
  "code": "CX"
},
{
  "name": "Cocos (Keeling) Islands",
  "dial_code": "61",
  "emoji": "🇨🇨",
  "code": "CC"
},
{
  "name": "Colombia",
  "dial_code": "57",
  "emoji": "🇨🇴",
  "code": "CO"
},
{
  "name": "Comoros",
  "dial_code": "269",
  "emoji": "🇰🇲",
  "code": "KM"
},
{
  "name": "Congo",
  "dial_code": "242",
  "emoji": "🇨🇬",
  "code": "CG"
},
{
  "name": "Congo, The Democratic Republic of the Congo",
  "dial_code": "243",
  "emoji": "🇨🇩",
  "code": "CD"
},
{
  "name": "Cook Islands",
  "dial_code": "682",
  "emoji": "🇨🇰",
  "code": "CK"
},
{
  "name": "Costa Rica",
  "dial_code": "506",
  "emoji": "🇨🇷",
  "code": "CR"
},
{
  "name": "Cote d'Ivoire",
  "dial_code": "225",
  "emoji": "🇨🇮",
  "code": "CI"
},
{
  "name": "Croatia",
  "dial_code": "385",
  "emoji": "🇭🇷",
  "code": "HR"
},
{
  "name": "Cuba",
  "dial_code": "53",
  "emoji": "🇨🇺",
  "code": "CU"
},
{
  "name": "Cyprus",
  "dial_code": "357",
  "emoji": "🇨🇾",
  "code": "CY"
},
{
  "name": "Czech Republic",
  "dial_code": "420",
  "emoji": "🇨🇿",
  "code": "CZ"
},
{
  "name": "Denmark",
  "dial_code": "45",
  "emoji": "🇩🇰",
  "code": "DK"
},
{
  "name": "Djibouti",
  "dial_code": "253",
  "emoji": "🇩🇯",
  "code": "DJ"
},
{
  "name": "Dominica",
  "dial_code": "1767",
  "emoji": "🇩🇲",
  "code": "DM"
},
{
  "name": "Dominican Republic",
  "dial_code": "1849",
  "emoji": "🇩🇴",
  "code": "DO"
},
{
  "name": "Ecuador",
  "dial_code": "593",
  "emoji": "🇪🇨",
  "code": "EC"
},
{
  "name": "Egypt",
  "dial_code": "20",
  "emoji": "🇪🇬",
  "code": "EG"
},
{
  "name": "El Salvador",
  "dial_code": "503",
  "emoji": "🇸🇻",
  "code": "SV"
},
{
  "name": "Equatorial Guinea",
  "dial_code": "240",
  "emoji": "🇬🇶",
  "code": "GQ"
},
{
  "name": "Eritrea",
  "dial_code": "291",
  "emoji": "🇪🇷",
  "code": "ER"
},
{
  "name": "Estonia",
  "dial_code": "372",
  "emoji": "🇪🇪",
  "code": "EE"
},
{
  "name": "Ethiopia",
  "dial_code": "251",
  "emoji": "🇪🇹",
  "code": "ET"
},
{
  "name": "Falkland Islands (Malvinas)",
  "dial_code": "500",
  "emoji": "🇫🇰",
  "code": "FK"
},
{
  "name": "Faroe Islands",
  "dial_code": "298",
  "emoji": "🇫🇴",
  "code": "FO"
},
{
  "name": "Fiji",
  "dial_code": "679",
  "emoji": "🇫🇯",
  "code": "FJ"
},
{
  "name": "Finland",
  "dial_code": "358",
  "emoji": "🇫🇮",
  "code": "FI"
},
{
  "name": "France",
  "dial_code": "33",
  "emoji": "🇫🇷",
  "code": "FR"
},
{
  "name": "French Guiana",
  "dial_code": "594",
  "emoji": "🇬🇫",
  "code": "GF"
},
{
  "name": "French Polynesia",
  "dial_code": "689",
  "emoji": "🇵🇫",
  "code": "PF"
},
{
  "name": "Gabon",
  "dial_code": "241",
  "emoji": "🇬🇦",
  "code": "GA"
},
{
  "name": "Gambia",
  "dial_code": "220",
  "emoji": "🇬🇲",
  "code": "GM"
},
{
  "name": "Georgia",
  "dial_code": "995",
  "emoji": "🇬🇪",
  "code": "GE"
},
{
  "name": "Germany",
  "dial_code": "49",
  "emoji": "🇩🇪",
  "code": "DE"
},
{
  "name": "Ghana",
  "dial_code": "233",
  "emoji": "🇬🇭",
  "code": "GH"
},
{
  "name": "Gibraltar",
  "dial_code": "350",
  "emoji": "🇬🇮",
  "code": "GI"
},
{
  "name": "Greece",
  "dial_code": "30",
  "emoji": "🇬🇷",
  "code": "GR"
},
{
  "name": "Greenland",
  "dial_code": "299",
  "emoji": "🇬🇱",
  "code": "GL"
},
{
  "name": "Grenada",
  "dial_code": "1473",
  "emoji": "🇬🇩",
  "code": "GD"
},
{
  "name": "Guadeloupe",
  "dial_code": "590",
  "emoji": "🇬🇵",
  "code": "GP"
},
{
  "name": "Guam",
  "dial_code": "1671",
  "emoji": "🇬🇺",
  "code": "GU"
},
{
  "name": "Guatemala",
  "dial_code": "502",
  "emoji": "🇬🇹",
  "code": "GT"
},
{
  "name": "Guernsey",
  "dial_code": "44",
  "emoji": "🇬🇬",
  "code": "GG"
},
{
  "name": "Guinea",
  "dial_code": "224",
  "emoji": "🇬🇳",
  "code": "GN"
},
{
  "name": "Guinea-Bissau",
  "dial_code": "245",
  "emoji": "🇬🇼",
  "code": "GW"
},
{
  "name": "Guyana",
  "dial_code": "595",
  "emoji": "🇬🇾",
  "code": "GY"
},
{
  "name": "Haiti",
  "dial_code": "509",
  "emoji": "🇭🇹",
  "code": "HT"
},
{
  "name": "Holy See (Vatican City State)",
  "dial_code": "379",
  "emoji": "🇻🇦",
  "code": "VA"
},
{
  "name": "Honduras",
  "dial_code": "504",
  "emoji": "🇭🇳",
  "code": "HN"
},
{
  "name": "Hong Kong",
  "dial_code": "852",
  "emoji": "🇭🇰",
  "code": "HK"
},
{
  "name": "Hungary",
  "dial_code": "36",
  "emoji": "🇭🇺",
  "code": "HU"
},
{
  "name": "Iceland",
  "dial_code": "354",
  "emoji": "🇮🇸",
  "code": "IS"
},
{
  "name": "India",
  "dial_code": "91",
  "emoji": "🇮🇳",
  "code": "IN"
},
{
  "name": "Indonesia",
  "dial_code": "62",
  "emoji": "🇮🇩",
  "code": "ID"
},
{
  "name": "Iran, Islamic Republic of Persian Gulf",
  "dial_code": "98",
  "emoji": "🇮🇷",
  "code": "IR"
},
{
  "name": "Iraq",
  "dial_code": "964",
  "emoji": "🇮🇷",
  "code": "IQ"
},
{
  "name": "Ireland",
  "dial_code": "353",
  "emoji": "🇮🇪",
  "code": "IE"
},
{
  "name": "Isle of Man",
  "dial_code": "44",
  "emoji": "🇮🇲",
  "code": "IM"
},
{
  "name": "Israel",
  "dial_code": "972",
  "emoji": "🇮🇱",
  "code": "IL"
},
{
  "name": "Italy",
  "dial_code": "39",
  "emoji": "🇮🇹",
  "code": "IT"
},
{
  "name": "Jamaica",
  "dial_code": "1876",
  "emoji": "🇯🇲",
  "code": "JM"
},
{
  "name": "Japan",
  "dial_code": "81",
  "emoji": "🇯🇵",
  "code": "JP"
},
{
  "name": "Jersey",
  "dial_code": "44",
  "emoji": "🇯🇪",
  "code": "JE"
},
{
  "name": "Jordan",
  "dial_code": "962",
  "emoji": "🇯🇴",
  "code": "JO"
},
{
  "name": "Kazakhstan",
  "dial_code": "77",
  "emoji": "🇰🇿",
  "code": "KZ"
},
{
  "name": "Kenya",
  "dial_code": "254",
  "emoji": "🇰🇪",
  "code": "KE"
},
{
  "name": "Kiribati",
  "dial_code": "686",
  "emoji": "🇰🇮",
  "code": "KI"
},
{
  "name": "Korea, Democratic People's Republic of Korea",
  "dial_code": "850",
  "emoji": "🇰🇵",
  "code": "KP"
},
{
  "name": "Korea, Republic of South Korea",
  "dial_code": "82",
  "emoji": "🇰🇷",
  "code": "KR"
},
{
  "name": "Kuwait",
  "dial_code": "965",
  "emoji": "🇰🇼",
  "code": "KW"
},
{
  "name": "Kyrgyzstan",
  "dial_code": "996",
  "emoji": "🇰🇬",
  "code": "KG"
},
{
  "name": "Laos",
  "dial_code": "856",
  "emoji": "🇱🇦",
  "code": "LA"
},
{
  "name": "Latvia",
  "dial_code": "371",
  "emoji": "🇱🇻",
  "code": "LV"
},
{
  "name": "Lebanon",
  "dial_code": "961",
  "emoji": "🇱🇧",
  "code": "LB"
},
{
  "name": "Lesotho",
  "dial_code": "266",
  "emoji": "🇱🇸",
  "code": "LS"
},
{
  "name": "Liberia",
  "dial_code": "231",
  "emoji": "🇱🇷",
  "code": "LR"
},
{
  "name": "Libyan Arab Jamahiriya",
  "dial_code": "218",
  "emoji": "🇱🇾",
  "code": "LY"
},
{
  "name": "Liechtenstein",
  "dial_code": "423",
  "emoji": "🇱🇮",
  "code": "LI"
},
{
  "name": "Lithuania",
  "dial_code": "370",
  "emoji": "🇱🇹",
  "code": "LT"
},
{
  "name": "Luxembourg",
  "dial_code": "352",
  "emoji": "🇱🇺",
  "code": "LU"
},
{
  "name": "Macao",
  "dial_code": "853",
  "emoji": "🇲🇴",
  "code": "MO"
},
{
  "name": "Macedonia",
  "dial_code": "389",
  "emoji": "🇲🇰",
  "code": "MK"
},
{
  "name": "Madagascar",
  "dial_code": "261",
  "emoji": "🇲🇬",
  "code": "MG"
},
{
  "name": "Malawi",
  "dial_code": "265",
  "emoji": "🇲🇼",
  "code": "MW"
},
{
  "name": "Malaysia",
  "dial_code": "60",
  "emoji": "🇲🇾",
  "code": "MY"
},
{
  "name": "Maldives",
  "dial_code": "960",
  "emoji": "🇲🇻",
  "code": "MV"
},
{
  "name": "Mali",
  "dial_code": "223",
  "emoji": "🇲🇱",
  "code": "ML"
},
{
  "name": "Malta",
  "dial_code": "356",
  "emoji": "🇲🇹",
  "code": "MT"
},
{
  "name": "Marshall Islands",
  "dial_code": "692",
  "emoji": "🇲🇭",
  "code": "MH"
},
{
  "name": "Martinique",
  "dial_code": "596",
  "emoji": "🇲🇶",
  "code": "MQ"
},
{
  "name": "Mauritania",
  "dial_code": "222",
  "emoji": "🇲🇷",
  "code": "MR"
},
{
  "name": "Mauritius",
  "dial_code": "230",
  "emoji": "🇲🇺",
  "code": "MU"
},
{
  "name": "Mayotte",
  "dial_code": "262",
  "emoji": "🇾🇹",
  "code": "YT"
},
{
  "name": "Mexico",
  "dial_code": "52",
  "emoji": "🇲🇽",
  "code": "MX"
},
{
  "name": "Micronesia, Federated States of Micronesia",
  "dial_code": "691",
  "emoji": "🇫🇲",
  "code": "FM"
},
{
  "name": "Moldova",
  "dial_code": "373",
  "emoji": "🇲🇩",
  "code": "MD"
},
{
  "name": "Monaco",
  "dial_code": "377",
  "emoji": "🇲🇨",
  "code": "MC"
},
{
  "name": "Mongolia",
  "dial_code": "976",
  "emoji": "🇲🇳",
  "code": "MN"
},
{
  "name": "Montenegro",
  "dial_code": "382",
  "emoji": "🇲🇪",
  "code": "ME"
},
{
  "name": "Montserrat",
  "dial_code": "1664",
  "emoji": "🇲🇸",
  "code": "MS"
},
{
  "name": "Morocco",
  "dial_code": "212",
  "emoji": "🇲🇦",
  "code": "MA"
},
{
  "name": "Mozambique",
  "dial_code": "258",
  "emoji": "🇲🇿",
  "code": "MZ"
},
{
  "name": "Myanmar",
  "dial_code": "95",
  "emoji": "🇲🇲",
  "code": "MM"
},
{
  "name": "Namibia",
  "emoji": "🇳🇦",
  "dial_code": "264",
  "code": "NA"
},
{
  "name": "Nauru",
  "dial_code": "674",
  "emoji": "🇳🇷",
  "code": "NR"
},
{
  "name": "Nepal",
  "dial_code": "977",
  "emoji": "🇳🇵",
  "code": "NP"
},
{
  "name": "Netherlands",
  "dial_code": "31",
  "emoji": "🇳🇱",
  "code": "NL"
},
{
  "name": "Netherlands Antilles",
  "dial_code": "599",
  "emoji": "🇧🇶",
  "code": "AN"
},
{
  "name": "New Caledonia",
  "dial_code": "687",
  "emoji": "🇳🇨",
  "code": "NC"
},
{
  "name": "New Zealand",
  "dial_code": "64",
  "emoji": "🇳🇿",
  "code": "NZ"
},
{
  "name": "Nicaragua",
  "dial_code": "505",
  "emoji": "🇳🇮",
  "code": "NI"
},
{
  "name": "Niger",
  "dial_code": "227",
  "emoji": "🇳🇪",
  "code": "NE"
},
{
  "name": "Nigeria",
  "dial_code": "234",
  "emoji": "🇳🇬",
  "code": "NG"
},
{
  "name": "Niue",
  "dial_code": "683",
  "emoji": "🇳🇺",
  "code": "NU"
},
{
  "name": "Norfolk Island",
  "dial_code": "672",
  "emoji": "🇳🇫",
  "code": "NF"
},
{
  "name": "Northern Mariana Islands",
  "dial_code": "1670",
  "emoji": "🇲🇵",
  "code": "MP"
},
{
  "name": "Norway",
  "dial_code": "47",
  "emoji": "🇳🇴",
  "code": "NO"
},
{
  "name": "Oman",
  "dial_code": "968",
  "emoji": "🇴🇲",
  "code": "OM"
},
{
  "name": "Pakistan",
  "dial_code": "92",
  "emoji": "🇵🇰",
  "code": "PK"
},
{
  "name": "Palau",
  "dial_code": "680",
  "emoji": "🇵🇼",
  "code": "PW"
},
{
  "name": "Palestinian Territory, Occupied",
  "dial_code": "970",
  "emoji": "🇵🇸",
  "code": "PS"
},
{
  "name": "Panama",
  "dial_code": "507",
  "emoji": "🇵🇦",
  "code": "PA"
},
{
  "name": "Papua New Guinea",
  "dial_code": "675",
  "emoji": "🇵🇬",
  "code": "PG"
},
{
  "name": "Paraguay",
  "dial_code": "595",
  "emoji": "🇵🇾",
  "code": "PY"
},
{
  "name": "Peru",
  "dial_code": "51",
  "emoji": "🇵🇪",
  "code": "PE"
},
{
  "name": "Philippines",
  "dial_code": "63",
  "emoji": "🇵🇭",
  "code": "PH"
},
{
  "name": "Pitcairn",
  "dial_code": "872",
  "emoji": "🇵🇳",
  "code": "PN"
},
{
  "name": "Poland",
  "dial_code": "48",
  "emoji": "🇵🇱",
  "code": "PL"
},
{
  "name": "Portugal",
  "dial_code": "351",
  "emoji": "🇵🇹",
  "code": "PT"
},
{
  "name": "Puerto Rico",
  "dial_code": "1939",
  "emoji": "🇵🇷",
  "code": "PR"
},
{
  "name": "Qatar",
  "dial_code": "974",
  "emoji": "🇶🇦",
  "code": "QA"
},
{
  "name": "Romania",
  "dial_code": "40",
  "emoji": "🇷🇴",
  "code": "RO"
},
{
  "name": "Russia",
  "dial_code": "7",
  "emoji": "🇷🇺",
  "code": "RU"
},
{
  "name": "Rwanda",
  "dial_code": "250",
  "emoji": "🇷🇼",
  "code": "RW"
},
{
  "name": "Reunion",
  "dial_code": "262",
  "emoji": "🇷🇪",
  "code": "RE"
},
{
  "name": "Saint Barthelemy",
  "dial_code": "590",
  "emoji": "🇧🇱",
  "code": "BL"
},
{
  "name": "Saint Helena, Ascension and Tristan Da Cunha",
  "dial_code": "290",
  "emoji": "🇸🇭",
  "code": "SH"
},
{
  "name": "Saint Kitts and Nevis",
  "dial_code": "1869",
  "emoji": "🇰🇳",
  "code": "KN"
},
{
  "name": "Saint Lucia",
  "dial_code": "1758",
  "emoji": "🇱🇨",
  "code": "LC"
},
{
  "name": "Saint Martin",
  "dial_code": "590",
  "emoji": "🇲🇫",
  "code": "MF"
},
{
  "name": "Saint Pierre and Miquelon",
  "dial_code": "508",
  "emoji": "🇵🇲",
  "code": "PM"
},
{
  "name": "Saint Vincent and the Grenadines",
  "dial_code": "1784",
  "emoji": "🇻🇨",
  "code": "VC"
},
{
  "name": "Samoa",
  "dial_code": "685",
  "emoji": "🇼🇸",
  "code": "WS"
},
{
  "name": "San Marino",
  "dial_code": "378",
  "emoji": "🇸🇲",
  "code": "SM"
},
{
  "name": "Sao Tome and Principe",
  "dial_code": "239",
  "emoji": "🇸🇹",
  "code": "ST"
},
{
  "name": "Saudi Arabia",
  "dial_code": "966",
  "emoji": "🇸🇦",
  "code": "SA"
},
{
  "name": "Senegal",
  "dial_code": "221",
  "emoji": "🇸🇳",
  "code": "SN"
},
{
  "name": "Serbia",
  "dial_code": "381",
  "emoji": "🇷🇸",
  "code": "RS"
},
{
  "name": "Seychelles",
  "dial_code": "248",
  "emoji": "🇸🇨",
  "code": "SC"
},
{
  "name": "Sierra Leone",
  "dial_code": "232",
  "emoji": "🇸🇱",
  "code": "SL"
},
{
  "name": "Singapore",
  "dial_code": "65",
  "emoji": "🇸🇬",
  "code": "SG"
},
{
  "name": "Slovakia",
  "dial_code": "421",
  "emoji": "🇸🇰",
  "code": "SK"
},
{
  "name": "Slovenia",
  "dial_code": "386",
  "emoji": "🇸🇮",
  "code": "SI"
},
{
  "name": "Solomon Islands",
  "dial_code": "677",
  "emoji": "🇸🇧",
  "code": "SB"
},
{
  "name": "Somalia",
  "dial_code": "252",
  "emoji": "🇸🇴",
  "code": "SO"
},
{
  "name": "South Africa",
  "dial_code": "27",
  "emoji": "🇿🇦",
  "code": "ZA"
},
{
  "name": "South Sudan",
  "dial_code": "211",
  "emoji": "🇸🇸",
  "code": "SS"
},
{
  "name": "South Georgia and the South Sandwich Islands",
  "dial_code": "500",
  "emoji": "🇬🇸",
  "code": "GS"
},
{
  "name": "Spain",
  "dial_code": "34",
  "emoji": "🇪🇸",
  "code": "ES"
},
{
  "name": "Sri Lanka",
  "dial_code": "94",
  "emoji": "🇱🇰",
  "code": "LK"
},
{
  "name": "Sudan",
  "dial_code": "249",
  "emoji": "🇸🇩",
  "code": "SD"
},
{
  "name": "Suriname",
  "dial_code": "597",
  "emoji": "🇸🇷",
  "code": "SR"
},
{
  "name": "Svalbard and Jan Mayen",
  "dial_code": "47",
  "emoji": "🇸🇯",
  "code": "SJ"
},
{
  "name": "Swaziland",
  "dial_code": "268",
  "emoji": "🇸🇿",
  "code": "SZ"
},
{
  "name": "Sweden",
  "dial_code": "46",
  "emoji": "🇸🇪",
  "code": "SE"
},
{
  "name": "Switzerland",
  "dial_code": "41",
  "emoji": "🇨🇭",
  "code": "CH"
},
{
  "name": "Syrian Arab Republic",
  "dial_code": "963",
  "emoji": "🇸🇾",
  "code": "SY"
},
{
  "name": "Taiwan",
  "dial_code": "886",
  "emoji": "🇹🇼",
  "code": "TW"
},
{
  "name": "Tajikistan",
  "dial_code": "992",
  "emoji": "🇹🇯",
  "code": "TJ"
},
{
  "name": "Tanzania, United Republic of Tanzania",
  "dial_code": "255",
  "emoji": "🇹🇿",
  "code": "TZ"
},
{
  "name": "Thailand",
  "dial_code": "66",
  "emoji": "🇹🇭",
  "code": "TH"
},
{
  "name": "Timor-Leste",
  "dial_code": "670",
  "emoji": "🇹🇱",
  "code": "TL"
},
{
  "name": "Togo",
  "dial_code": "228",
  "emoji": "🇹🇬",
  "code": "TG"
},
{
  "name": "Tokelau",
  "dial_code": "690",
  "emoji": "🇹🇰",
  "code": "TK"
},
{
  "name": "Tonga",
  "dial_code": "676",
  "emoji": "🇹🇴",
  "code": "TO"
},
{
  "name": "Trinidad and Tobago",
  "dial_code": "1868",
  "emoji": "🇹🇹",
  "code": "TT"
},
{
  "name": "Tunisia",
  "dial_code": "216",
  "emoji": "🇹🇳",
  "code": "TN"
},
{
  "name": "Turkey",
  "dial_code": "90",
  "emoji": "🇹🇷",
  "code": "TR"
},
{
  "name": "Turkmenistan",
  "dial_code": "993",
  "emoji": "🇹🇲",
  "code": "TM"
},
{
  "name": "Turks and Caicos Islands",
  "dial_code": "1649",
  "emoji": "🇹🇨",
  "code": "TC"
},
{
  "name": "Tuvalu",
  "dial_code": "688",
  "emoji": "🇹🇻",
  "code": "TV"
},
{
  "name": "Uganda",
  "dial_code": "256",
  "emoji": "🇺🇬",
  "code": "UG"
},
{
  "name": "Ukraine",
  "dial_code": "380",
  "emoji": "🇺🇦",
  "code": "UA"
},
{
  "name": "United Arab Emirates",
  "dial_code": "971",
  "emoji": "🇦🇪",
  "code": "AE"
},
{
  "name": "United Kingdom",
  "dial_code": "44",
  "emoji": "🇬🇧",
  "code": "GB"
},
{
  "name": "United States",
  "dial_code": "1",
  "emoji": "🇺🇸",
  "code": "US"
},
{
  "name": "Uruguay",
  "dial_code": "598",
  "emoji": "🇺🇾",
  "code": "UY"
},
{
  "name": "Uzbekistan",
  "dial_code": "998",
  "emoji": "🇺🇿",
  "code": "UZ"
},
{
  "name": "Vanuatu",
  "dial_code": "678",
  "emoji": "🇻🇺",
  "code": "VU"
},
{
  "name": "Venezuela, Bolivarian Republic of Venezuela",
  "dial_code": "58",
  "emoji": "🇻🇪",
  "code": "VE"
},
{
  "name": "Vietnam",
  "dial_code": "84",
  "emoji": "🇻🇳",
  "code": "VN"
},
{
  "name": "Virgin Islands, British",
  "dial_code": "1284",
  "emoji": "🇻🇬",
  "code": "VG"
},
{
  "name": "Virgin Islands, U.S.",
  "dial_code": "1340",
  "emoji": "🇻🇮",
  "code": "VI"
},
{
  "name": "Wallis and Futuna",
  "dial_code": "681",
  "emoji": "🇼🇫",
  "code": "WF"
},
{
  "name": "Yemen",
  "dial_code": "967",
  "emoji": "🇾🇪",
  "code": "YE"
},
{
  "name": "Zambia",
  "dial_code": "260",
  "emoji": "🇿🇲",
  "code": "ZM"
},
{
  "name": "Zimbabwe",
  "dial_code": "263",
  "emoji": "🇿🇼",
  "code": "ZW"
}
];

export const PrivacyInformation=[
    {
    id:1,
    subject: "1. Introduction",
    body:{
      "one":"1.1. These terms set out the terms and conditions upon which we, the Bank will provide banking services to you and references to ‘we’, ‘us’, or ‘our’ read to mean the Bank. References to ‘you’ or ‘your’ or ‘yourself’ are references to the person or persons in whose names the account is held.",
      "two":"1.2. The terms and conditions are limited to providing general banking services and form a legal agreement between you and us; so please confirm that you understand all of them.",
      "three":"1.3. The terms and conditions apply to all accounts (both transactional and savings) whether opened on the date of signing these terms and conditions or on a later/prior date.",
      "four":"1.4. We reserve the right to change or amend any or all of these terms upon giving you notice in accordance with the Bank of Uganda Consumer Protection Guidelines."
    }
      
    },
    /*{
      id:2,
      subject:"2. ACCOUNT OPENING",
      body:{
        "one":"2.1. By signing these terms, you guarantee the accuracy of the information submitted on this application. We shall not be held liable for any misrepresentation or any legal consequences arising from reliance on the information provided by yourself.",
        "two":"2.2. We may at our discretion decline to open an account for any applicant for an account. We are under no obligation to communicate the reason for our decision to the applicant.",
        "three":"2.3. At account opening and at any time throughout the lifetime of the account, you are agreeing to provide us with any supplementary documentation and information we may request for from time to time in order to undertake our due diligence as required.",
        "four":"2.4. You will provide us with specimen signatures of each of the persons authorized to operate your account.",
        "five":"2.5. If false or inaccurate information is provided and fraud is identified or suspected, your details may be forwarded to the relevant enforcement agencies for any further action as may be required."
      }
    },*/
    {
      id:3,
      subject:"3. Account Operation Obligations",
      body:{
        "one":"3.1. We shall not be liable whatsoever for funds handed to Bank Tellers outside banking hours and/or outside designated banking premises or channels",
        "two":"3.2. It shall be incumbent on you to request for and/or always acquire a duly signed deposit slip or acknowledgement receipt when you make a deposit transaction from any of our designated points of representation to aid your transaction confirmation and reconciliation.",
        "three":"3.3. You will authorize us to accept instructions signed by yourself/yourselves.",
        "four":"3.4. We shall not make any payment out of your account to any party unless you have consented by giving instruction in accordance to the mandate held by us.",
        "five":"3.5.  Any cancellation of an instruction shall be communicated to us at least one working day before the payment is due to be debited. For avoidance of doubt, the time of receipt is the time we receive the instructions not the time you send them",
        "six":"3.6. We shall at any time freeze your account as long as there is any dispute or reason to suspect any fraud on the persons entitled to operate the same.",
        "seven":"3.7. We shall at our discretion refuse to act on any instruction if.-We are unable to authenticate the origin of the instructions-The instructions are unclear, incomplete, not signed or not in the approved form.-The instruction would cause you to exceed authorized limits for your account.-Complying with the instruction would be contrary or in breach of any law/regulation applicable to us",
        "eight":"3.8. We shall notify you with reasons in case we decline to honor instructions, unless if we are limited by circumstances beyond our control preventing us to give this information.",
        "nine":"3.9. You shall always keep confidential your ATM Card/Password/PIN/Login credentials/phone messages, or any other security information secure to prevent any fraudulent use to them. We will not be held liable in case your password/PIN/Login credentials/phone messages are misappropriated by a third party to access and/or transact on your account.",
        "ten":"3.10. Your ATM card withdraw transaction limit per day shall not exceed such amounts as determined and advised by the bank from time to time at its sole discretion.",
        "eleven":"3.11. You shall within 24 hours write to us if any card/PIN/security device or security details are lost or stolen or suspect to be used or accessed by an unauthorized person.",
    }
    },
    {
      id:4,
      subject:"4. Complaints",
      body:{
        "one":"We shall not be liable for any matters unless you make a complaint to us as soon as reasonably possible either verbally or in writing, through our official communication or feedback channels provided."
      }
    },
    {
      id:5,
      subject:"5. Incident Communication",
      body:{
        "one":"5.1. You will communicate to us in writing in the event of any significant incident or decision alteration (such as change in signatories or signing mandate) in the general operations of your account. ",
        "two":"5.2. In the unfortunate event of death of any signatory of a joint account holding, the survivor(s) undertake(s) to advise the bank in writing of such death within reasonable time. In absence of acknowledgment (in any form) of receipt of such notification, the Bank shall not be held liable for allowing continuation of operations on any affected account(s)."
      }
    },
    {
      id:6,
      subject:"6. Bank Charges",
      body:{
        "one":"6.1. We may apply charges for use of the account and for services provided to you in accordance with our prevailing tariff guide in accordance with the Consumer Protection Guidelines issued by the regulator",
        "two":"6.2. We may apply new or revised charges to your account at least 30 calendar days after the change notice is given in print media and displayed in our designated branches and website.",
        "three":"6.3. We are mandated to debit your account for any of the following;-Interest on any facility granted by us at a prescribed date, unless otherwise agreed in writing.-All charges including but not limited to statement printing, taxes and duties and any other expense incurred in operating this account."
      }
    },
    {
      id:7,
      subject:"7. Debit Instruments",
      body:{
        "one":"7.1. We have the discretion to issue you with a debit card for operations of your account and to retain or cancel your instruments if there is any suspicion of fraud regarding your account.",
        "two":"7.2. We shall not be liable for any loss arising from lost or misplaced debit instruments e.g. In-house vouchers or voucher book(s) if we are not notified within a reasonable period (at most within 24 hours of its loss)."
      }
    },
    {
      id:8,
      subject:"8. Statements",
      body:{
        "one":"8.1. We shall provide you with free regular electronic copies of your statements onto your availed email address and upon registration on the Bank’s internet banking platform, the same shall be available online. Any paper statements or additional requests will be charged in accordance with our prevailing tariff guid",
        "two":"8.2. We shall avail your transactional information for a period of 10 years preceding the date of request in accordance with the regulations; any information required exceeding 10 years will be at our discretion."
      }
    },
    {
      id:9,
      subject:"9. Disclosure Of Personal Data",
      body:{
        "one":"9.1 You consent i. To providing your personal data as submitted herein to PostBank Uganda Ltd for purposes of accessing financial services. ii. That the Bank may in exercise of its responsibilities and in fulfilment of its mandate as a financial services provider and a regulated financial institution in compliance with the relevant laws, regulations and guidelines as issued by the Regulator or other competent authority, collect, control, process, share, exchange and/or store your personal data with its relevant business stakeholders in any part of the world.",
        "two":"9.2 Notice:You are hereby issued notice to the effect that; i. Provision of your personal data as prescribed in this form to the Bank is a mandatory legal and regulatory requirement under the Financial Institutions Act,2004 (as amended), The Anti-Money Laundering Act, 2003 (as amended) , The Anti-Money Laundering Regulations and, The Registration of Persons Act,2015.ii. Failure to provide all the data required in this form shall be ground enough to restrict you from accessing the desired financial services from the Bank.iii. Authorized Bank officials, agents ,partners and/or vendors shall have access to your personal data for purposes of delivering financial services to you and, meeting other institutional regulatory and legal obligations.iv. You have a right of access to, right to request rectification and deletion of data collected before and after the collection and; v. Your data shall be retained by the Bank for as long as this relationship is maintained. Upon termination of this relationship, the Bank shall retain your personal data for a minimum period of ten years"
      }
    },
    /*{
      id:10,
      subject:"10. INACTIVE ACCOUNTS",
      body:{
        "one":"10.1. Your account will be classified as inactive if there are no customer-initiated transactions for a consecutive period of 6 months. Anytime thereafter, you may be given 14 calendar days’ notice to re-activate or authorize its closure",
        "two":"10.2. In any case, if this inactivity continues for a consecutive period of 2 calendar years the account shall be classified as dormant and, it shall be dealt with in accordance with the prevailing laws of the country"
      }
    },
    {
      id:11,
      subject:"11. CLOSING OF ACCOUNT",
      body:{
        "one":"11.1. You reserve the right to give us written instructions to close your account as per the signed mandate.",
        "two":"11.2. We may terminate your account immediately if we have reasonable grounds to suspect any of the following:-That you provided us with false information.-That it is being used for illegal dealings."     
      }
    },
    {
      id:12,
      subject:"12. BANKS RIGHT TO SET OFF",
      body:{
        "one":"We may upon giving you reasonable notice, set off any sums against any indebtedness in respect of which you are liable notwithstanding that some other person may also be liable in respect thereof. "
      }
    },*/
       
  ]